import React from 'react';
import PropTypes from 'prop-types';
import { modalViewGA } from '../../utils/googleAnalytics';

const propTypes = {
  removeModal: PropTypes.func,
};

const defaultProps = {
  removeModal: () => {},
};

class SuccessfulRegistrationModal extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.complete = this.complete.bind(this);
  }

  closeModal(e) {
    if (e) e.preventDefault();
    this.props.removeModal();
  }

  componentDidMount() {
    modalViewGA('complete-registration');
  }

  complete() {
    this.closeModal();
  }

  render() {
    return (
      <div>
        <div className="modals-popup signup-modal u-font-foundation-roman">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Welcome to Explore!</div>
          </div>

          <div className="info text-center">
            <div className="intro-text">
              <div>Thanks for signing up for Explore!</div>
              <div className="text-center text-white pt-4">
                <a id="complete-registration" className="btn btn-lg btn-success" onClick={this.closeModal} >Finish</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SuccessfulRegistrationModal.propTypes = propTypes;
SuccessfulRegistrationModal.defaultProps = defaultProps;

export default SuccessfulRegistrationModal;
